import React from 'react';
import { Checkbox } from '@repo/common';

const ApplicationsListHeader = ({
  selectedTab,
  isAllSelected,
  onSelectAll,
}) => {
  const isSubmitted = selectedTab === 'submitted';
  const isSaved = selectedTab === 'saved';

  return (
    <div className='flex w-full items-center pb-4 bg-grayscale-gray00 typo-b13Strong text-text-primary'>
      <div className='flex px-2 justify-center items-center'>
        <Checkbox
          checked={isAllSelected}
          onChange={(e) => onSelectAll(e.target.checked)}
        />
      </div>
      <div className='flex px-2 justify-center items-center'>
        <div className='size-6' />
      </div>
      <div className='flex max-w-[140px] flex-1 w-full px-2 py-4 justify-start items-center'>
        Company
      </div>
      <div
        className={`flex flex-1 w-full ${
          isSubmitted
            ? 'max-w-[360px]'
            : isSaved
            ? 'max-w-[620px]'
            : 'max-w-[490px]'
        } px-2 py-4 justify-center items-center`}
      >
        Job title
      </div>
      {!isSaved && (
        <div className='flex max-w-[130px] flex-1 w-full px-2 py-4 justify-center items-center'>
          Applied by
        </div>
      )}
      {isSubmitted && (
        <div className='flex max-w-[130px] flex-1 w-full px-2 py-4 justify-center items-center'>
          Status
        </div>
      )}
    </div>
  );
};

export default ApplicationsListHeader;
